<template>
  <el-date-picker
    v-model="expiryDate"
    size="small"
    ref="datePicker"
    :pickerOptions="pickerOptions"
    @change="dateChagne"
    :editable="editable"
    value-format="yyyy-MM-dd"
  ></el-date-picker>
</template>

<script>
let forever = new Date("2099-12-31").getTime();
let today = new Date(new Date().toLocaleDateString()).getTime();
export default {
  props: {
    value: String,
    editable: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  watch: {
    value(newVal) {
      this.expiryDate = newVal;
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > forever || time.getTime() < today;
        },
        shortcuts: [
          {
            text: "一个月",
            onClick(picker) {
              const date = new Date();
              let year = date.getFullYear(); //获取当前日期的年份
              let month = date.getMonth() + 1; //获取当前日期的月份
              let day = date.getDate(); //获取当前日期的日
              let days = new Date(year, month, 0);
              let year2 = year;
              let month2 = parseInt(month) + 1;
              if (month2 == 13) {
                year2 = parseInt(year2) + 1;
                month2 = 1;
              }
              let day2 = day;
              let days2 = new Date(year2, month2, 0);
              days2 = days2.getDate();
              if (day2 > days2) {
                day2 = days2;
              }
              if (month2 < 10) {
                month2 = "0" + month2;
              }
              let t2 = year2 + "-" + month2 + "-" + day2;
              picker.$emit("pick", new Date(t2));
            }
          },
          {
            text: "一年",
            onClick(picker) {
              const date = new Date();
              date.setFullYear(date.getFullYear() + 1);
              picker.$emit("pick", date);
            }
          },
          {
            text: "永久",
            onClick(picker) {
              const date = new Date("2099-12-31");
              picker.$emit("pick", date);
            }
          }
        ]
      },
      expiryDate: this.value
    };
  },
  methods: {
    dateChagne(val) {
      this.$emit("change", val);
    },
    showPicker() {
      this.$refs.datePicker.showPicker();
    }
  }
};
</script>

<style>
</style>